import React from "react";
import { FaCheck } from "react-icons/fa6";
import * as Styles from "../../styles";
import { CustomTooltip } from "../../customTooltip";

interface Props {
  observacaoUltimaTarefa: string;
}

export const UltimaTarefaCell: React.FC<Props> = ({
  observacaoUltimaTarefa,
}) => (
  <CustomTooltip
    followCursor
    title={
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "4px 0px",
          gap: 8,
        }}
      >
        <div>
          <FaCheck size={14} />
        </div>
        <p>{observacaoUltimaTarefa || "--"}</p>
      </div>
    }
    placement="top-start"
  >
    <Styles.Td className="obsTd">
      <FaCheck />
    </Styles.Td>
  </CustomTooltip>
);
